import { PanelContent } from '../../components/PanelContent';
import { PanelHeader } from '../../components/PanelHeader';
import { DisconnectDialog } from './DisconnectDialog';
import { IntegrationsSection } from './IntegrationsSection';

export const Integrations = () => {
  return (
    <>
      <PanelHeader>Canva integration</PanelHeader>
      <PanelContent>
        <IntegrationsSection />
      </PanelContent>

      <DisconnectDialog />
    </>
  );
};
